import React from 'react';
import { StanButton } from '@/components';
import IcClock from '@/assets/icons/ic-clock.svg';
import { getMFADescription, getMFATitle, MFAConfigSource } from '../../../constants/mfa';
import IcLock from '@/assets/icons/ic-lock.svg';

interface MFAMethodChoiceProps {
    source: MFAConfigSource;
    onSelectAuthenticator: () => void;
    isLoading?: boolean;
}

export const MFAMethodChoice: React.FC<MFAMethodChoiceProps> = ({
    source,
    onSelectAuthenticator,
    isLoading = false,
}) => {
    const title = getMFATitle('method_choice', source);
    const description = getMFADescription('method_choice', source);

    return (
        <div className='flex flex-col items-center text-center'>
            {/* Header */}
            <div className='mb-4 flex flex-col items-center'>
                {/* <div className='bg-brand-soft mb-4 flex size-12 items-center justify-center rounded-full'>
                    <img src='/images/icons/ic-lock.svg' alt='Lock' className='size-6' />
                </div> */}
                <IcLock className='mb-2 size-14' />
                <h3 className='text-heading-h3 mb-2'>{title}</h3>
                <p className='text-gray text-body-sm'>
                    {description}{' '}
                    <a
                        href='https://help.stan.store/article/408-2fa'
                        target='_blank'
                        rel='noopener noreferrer'
                        className='text-brand-main hover:underline'
                    >
                        Learn more
                    </a>
                </p>
            </div>

            {/* Method Options */}
            <div className='mt-3 flex w-full flex-col gap-1'>
                <StanButton
                    name='mfa-method-choice-modal-button'
                    onClick={onSelectAuthenticator}
                    loading={isLoading}
                    disabled={isLoading}
                    icon={IcClock}
                >
                    Code from authenticator
                </StanButton>
                <p className='text-gray text-body-sm font-normal'>Generate a one-time code in your authenticator app</p>
            </div>
        </div>
    );
};
